(function($) {
    $(document).ready(function() {
        $(".yacht-range__list-item").on("click", function() {
            if(!$(this).hasClass("active")) {
                let target = $(this).attr("data-target");
                let $container = $(this).parents(".yacht-range"); 
                
                //Tab Selection
                $(".yacht-range__list-item", $container).each(function() {
                    $(this).removeClass("active");
                });
                
                $(this).addClass("active");
                
                //Section Display
                $(".yacht-range__section.active", $container).removeClass("active").fadeOut(400, function() {
                    $("[data-tab=" + target + "]").addClass("active").fadeIn().children(".other-boats").slick('setPosition');
                });
            } 
        });

        $(".yacht-range__slide-navigation").on('click', function() {
            $(this).toggleClass("selector-expand");
        });
        
    })
})(jQuery);